module.exports = __webpack_public_path__ + "static/serbia-01741968aaa60af392e90a9eb2620b87.jpg";